import { FC, SetStateAction, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { findProductSizes } from '../../../api/brands/findProductSizes';
import { signalFailingImageUrl } from '../../../api/products/signalFailingImg';
import { useAccountCreationContext } from '../../../common/context/AccountCreationContext';
import { Brand, Size } from '../../../common/types';
import OptionButton from '../../buttons/OptionButton';
import PrimaryParagraph from '../../texts/PrimaryParagraph';
import PrimaryTitle from '../../texts/PrimaryTitle';
import { SizeSelectionViewProps } from '../types';
import BrandSearchInput from '../../inputs/BrandSearchInput';
import SizeSearchInput from '../../inputs/SizeSearchInput';

const SizeSelectionView: FC<SizeSelectionViewProps> = (props) => {
	console.debug("[SizeSelection] rendered!");
	const { shoppingPreference, brands, items, setItems, selectedProducts } = useAccountCreationContext();

	const [brand, setBrand] = useState(brands[props.brandIndex]);
	const [fetchSizesLoading, setFetchSizesLoading] = useState<boolean>(false);
	const [fetchedSizes, setFetchedSizes] = useState<Size[]>([]);
	const selectedProduct = selectedProducts[props.brandIndex];
	const { t } = useTranslation();

	const handleNext = (size: Size) => {
		// Update the existing item at brandIndex instead of appending a new one
		const updatedItems = [...items];
		const existingItem = updatedItems[props.brandIndex];
		
		console.debug('🔍 [SIZE_SELECTION] Before merge:', {
			existingItem,
			brandIndex: props.brandIndex,
			typeLabelLong: props.typeLabelLong,
			brandCode: brand.code,
			sizeLabel: size.label
		});
		
		const completedItem = {
			...existingItem, // Preserve existing data
			brandCode: brand.code,
			sizeLabel: size.label,
			firestoreId: selectedProduct ? selectedProduct.firestore_id : null,
			typeLabelLong: props.typeLabelLong,
			typeSubCategory: props.typeSubCategory || '',
		};
		
		updatedItems[props.brandIndex] = completedItem;
		
		console.debug('🔍 [SIZE_SELECTION] After merge:', completedItem);
		setItems(updatedItems);
		
		console.debug('✅ Choice added:', {
			brandCode: brand.code,
			firestoreId: selectedProduct?.firestore_id,
			sizeLabel: size.label,
			typeLabelLong: props.typeLabelLong,
		});
		
		// Pass the completed item to handleNextStep so RegisterView can use it immediately
		props.handleNextStep?.([completedItem]);
	};

	useEffect(() => {
		setBrand(brands[props.brandIndex]);

		const fetchSizes = async () => {
			setFetchSizesLoading(true);
			try {
				const sizes = await findProductSizes(
					selectedProduct?.firestore_id || '',
					brand.code,
					props.typeLabelLong,
					shoppingPreference
				);
				setFetchedSizes(sizes);
			} catch (err) {
				console.error('❌ Failed to fetch sizes:', err);
				setFetchedSizes([]);
			} finally {
				setFetchSizesLoading(false);
			}
		};

		fetchSizes();
  }, [brands, props.brandIndex, selectedProduct, brand.code, props.typeLabelLong, shoppingPreference]);

	return (
		<div className={'pop-max-h-[450px] pop-fadeIn pop-w-full pop-mb-4'}>
			<div className={'pop-flex pop-flex-col pop-w-full pop-justify-center pop-items-center'}>
				<PrimaryTitle className="pop-text-center pop-my-2">{t('size_search_title')}</PrimaryTitle>

				<PrimaryParagraph className={'pop-text-center pop-mb-2'}>{t('size_select_message')} {brand.name}</PrimaryParagraph>
				<div className={'pop-flex pop-flex-col pop-w-full pop-justify-center pop-items-center'}>
					{selectedProduct?.product_images?.[0] && (
						<img
							className={'pop-w-20 pop-h-auto pop-rounded-xl pop-shadow-md pop-my-4'}
							src={selectedProduct.product_images[0]}
							alt={selectedProduct.product_label || 'Product'}
							onError={() => signalFailingImageUrl(selectedProduct.product_images[0])}
						/>
						)}
					<SizeSearchInput
						recommendedSizes={fetchedSizes /* Size[]: {label: string} */}
						loading={fetchSizesLoading}
						onSelect={(size) => handleNext(size)}
						className="pop-w-full"
						/>
					{/*{fetchSizesLoading && <span className="pop-loading pop-loading-dots pop-loading-lg pop-my-16 pop-bg-popsizeGradientSecondary9050"></span>}*/}
					{/*{fetchedSizes.length === 0 && !fetchSizesLoading && (
						<PrimaryParagraph className={'pop-text-center pop-my-4'}>{t('no_size_available')}</PrimaryParagraph>
					)}*/}
					{/*{fetchedSizes.length > 0 && !fetchSizesLoading && (
						<div className={'pop-grid pop-grid-cols-5 pop-gap-3'}>
							{fetchedSizes.map((size) => (
								<OptionButton
									key={size.label}
									className={'pop-rounded-full pop-fadeIn'}
									onClick={() => handleNext(size)}
								>
									{size.label}
								</OptionButton>
							))}
						</div>
					)}*/}
				</div>
			</div>
		</div>
	);
};

export default SizeSelectionView;
